import User from "../models/User";
export const UserMixin = {
  data() {
    return {
      user: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new User({
        first_name: null,
        middle_name: null,
        last_name: null,
        gender: null,
        date_of_birth: null,
        email: null,
        calling_code: '64',
        mobile: null,
        country_id: 1,
        identity: null,
        is_blocked: false,
        address: null,
        account_type: 'personal',
        ecdd: false,
        is_email_verified: false,
        password: null,
        password_confirmation: null,
        role: null,
        permissions: []
      })
    }
  }
}
